import Base from './base';

export default {
  getList: async (): Promise<any> => (await Base()).get('/metadata'),
  getByType: async (type: string): Promise<any> => (await Base()).get(`/metadata/${type}`),
};
